import {Divider, Space} from 'antd';
import PropTypes from 'prop-types';
import React, {memo, useCallback} from 'react';
import {useQueryClient} from 'react-query';

import {CACHE_KEY_LIST_PROPOSAL_REQUEST} from '@/modules/proposalRequest/contants/proposalRequest';
import {createUpdateStatusMany} from '@/modules/proposalRequest/hooks/createUpdateStatusMany';
import ProposalRequestApiService from '@/modules/proposalRequest/services/ProposalRequestApiService';

const ProposalRequestBulkAction = ({selectedRowKeys}) => {
  const queryClient = useQueryClient();
  const EntityUpdateStatusManyButton = createUpdateStatusMany(ProposalRequestApiService.updateManyStatus, 'proposalRequest');

  const handleChange = useCallback(() => {
    queryClient.invalidateQueries(CACHE_KEY_LIST_PROPOSAL_REQUEST);
  }, [queryClient]);

  return (
    <Space size={0}>
      <Divider size={'small'} type="vertical"/>
      <EntityUpdateStatusManyButton items={selectedRowKeys} onChange={handleChange}/>
    </Space>
  );
};

ProposalRequestBulkAction.propTypes = {
  selectedRowKeys: PropTypes.array
};

export default memo(ProposalRequestBulkAction);
